module.exports = __webpack_public_path__ + "Flag-270.422a5de9034890f6fe86920d2bc3febd.svg";